
import { Action, State } from 'vuex-facing-decorator';
import { Component, Prop, Vue } from 'vue-facing-decorator'

/**
 * 省市区三级联动选择，modelValue 是 [省, 市, 区] 的**名称**数组（缺的层级给空串）。
 *
 * 存名字不存编码：电子面单接口要的是 provinceName / cityName / expAreaName，
 * 订单表、仓库表里存的也都是名字（见 background-code-node 的 express.service.ts），
 * 中途转成编码的话发货提交会对不上。
 */
@Component({})
export default class extends Vue {
  @Prop({
    default() {
      return [];
    }
  })
  modelValue: any;

  @Prop({
    default: "请选择地区"
  })
  placeholder: string;

  @Action("address/getAddress")
  getAddress

  @State((state) => state.address.hash)
  cityHash
  @State((state) => state.address.province)
  province

  created() {
    this.getAddress()
  }

  get areaOptions() {
    let buildChildren = (code) => {
      let map = (this.cityHash[code] && this.cityHash[code].children) || {};
      let list = Object.keys(map).map((key) => map[key]);
      /** 没有下一级了要返回 null，返回空数组的话级联会当成「还能展开」画个空箭头 */
      if (!list.length) return null;
      return list.map((item) => {
        return {
          value: item.name,
          label: item.name,
          children: buildChildren(item.code),
        };
      });
    }
    return (this.province || []).map((item) => {
      return {
        value: item.name,
        label: item.name,
        children: buildChildren(item.code),
      };
    });
  }

  get areaValue() {
    let list = this.modelValue || [];
    /** 级联要从第一级开始连续，中间断档后面就不认了，所以截到最后一个有值的为止 */
    let lastIndex = -1;
    list.forEach((item, index) => {
      if (item) lastIndex = index;
    });
    return list.slice(0, lastIndex + 1);
  }
  set areaValue(v) {
    let list = v || [];
    this.$emit("update:modelValue", [list[0] || "", list[1] || "", list[2] || ""]);
  }
}
